import { cn } from "@/lib/utils";

interface SkipLinkProps {
  targetId?: string;
  className?: string;
}

/**
 * Skip Link Component
 *
 * Provides keyboard users a way to bypass navigation and jump directly to main content.
 * The link is visually hidden until focused, then appears at the top of the viewport.
 *
 * Usage:
 * 1. Add <SkipLink /> as the first child in your App or layout component
 * 2. Ensure main content has id="main-content" (or customize with targetId prop)
 */
export function SkipLink({ targetId = "main-content", className }: SkipLinkProps) {
  return (
    <a
      href={`#${targetId}`}
      className={cn(
        // Visually hidden by default
        "sr-only",
        // Visible when focused
        "focus:not-sr-only focus:absolute focus:z-[9999]",
        "focus:top-4 focus:left-4",
        "focus:px-4 focus:py-2",
        "focus:bg-primary focus:text-primary-foreground",
        "focus:rounded-md focus:shadow-lg",
        "focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
        "font-medium text-sm",
        className
      )}
    >
      Saltar al contenido principal
    </a>
  );
}

export default SkipLink;
